import Vue from 'vue'
import VueRouter from 'vue-router'
import MediaSpend from '../views/MediaSpend.vue'
import CompetitorBenchmark from "../views/CompetitorBenchmark";
import ContentPerformance from "../views/ContentPerformance";
import SocialMedia from "../views/SocialMedia";
import Home from "../views/Home";
import MyProjects from "../views/MyProjects";

Vue.use(VueRouter);

const routes = [
    {
        path: '/dashboard',
        name: 'home',
        component: Home
    },
    {
        path: '/',
        name: 'my-projects',
        component: MyProjects
    },
    {
        path: '/media-spend',
        name: 'media-spend',
        component: MediaSpend
    },
    {
        path: '/social-media',
        name: 'social-media',
        component: SocialMedia
    },
    {
        path: '/competitor-benchmark',
        name: 'competitor-benchmark',
        component: CompetitorBenchmark
    },
    {
        path: '/content-performance',
        name: 'content-performance',
        component: ContentPerformance
    },
];

const router = new VueRouter({
    routes,
    linkActiveClass: 'active',
    mode: 'history'
});

export default router
